import _useResizeObserver from 'use-resize-observer';
export var useResizeObserver = _ref => {
  var {
    ref
  } = _ref;
  return _useResizeObserver({
    ref
  });
};
//# sourceMappingURL=useResizeObserver.js.map